module.exports = __webpack_public_path__ + "img/colorlogo.b2cbee50.png";